import { makeStyles } from '@material-ui/core';
import apnaLogo from './apna-logo.png';

const useStyles = makeStyles({
  img: {
    width: 'auto',
    height: 32,
    display: 'block',
    borderRadius: 6,
  },
});

export const LogoIcon = () => {
  const classes = useStyles();

  return (
    <img
      alt="Apna"
      className={classes.img}
      src={apnaLogo}
    />
  );
};
